import { createContext, useContext } from 'react';

import type * as Sentry from '@/sentry/init';

export type SentryContextType = {
  addBreadcrumb: typeof Sentry.addBreadcrumb,
  captureException: typeof Sentry.captureException,
  captureMessage: typeof Sentry.captureMessage,
}

export const defaultSentryContext = {
  addBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
    console.info(breadcrumb);
  },
  captureException(error: Error) {
    console.error(error);

    return error.name;
  },
  captureMessage(message: string) {
    console.info(message);

    return message;
  },
};

export const SentryContext = createContext<SentryContextType>(defaultSentryContext);

export function useSentry() {
  return useContext(SentryContext);
}
